import { render, staticRenderFns } from "./login-ws.vue?vue&type=template&id=0b936d12&scoped=true"
import script from "./login-ws.vue?vue&type=script&lang=js"
export * from "./login-ws.vue?vue&type=script&lang=js"
import style0 from "./login-ws.vue?vue&type=style&index=0&id=0b936d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b936d12",
  null
  
)

export default component.exports